import { render, staticRenderFns } from "./IFrameContainer.vue?vue&type=template&id=c644892a"
import script from "./IFrameContainer.ts?vue&type=script&lang=ts&external"
export * from "./IFrameContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports